import { render } from "./VtoHotswap.vue?vue&type=template&id=622662fb"
import script from "./VtoHotswap.vue?vue&type=script&lang=js"
export * from "./VtoHotswap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__